import { Outlet } from 'react-router-dom';
import { useSyncClientFromUrl } from '@/hooks/useClientId';
import { useAppSelector } from '@/stores/hooks';
import Loading from '@/components/Loading/Loading';

const ClientLayout = () => {
  useSyncClientFromUrl();
  const loading = useAppSelector((s) => s.activeClient.loading);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading className="text-primary" />
      </div>
    );
  }

  return <Outlet />;
};

export default ClientLayout;